import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type ICreateSurveyCancelModal from './interfaces/ICreateSurveyCancelModal';

import styles from './scss/CreateSurveyCancelModal.module.scss';

function CreateSurveyCancelModal({
  open,
  onCancel,
  onCloseWithoutSaving,
  onSaveDraft,
  isLoading = false,
}: ICreateSurveyCancelModal) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={t('materialityAssessment.saveDraftModal.title')}
      description={t('materialityAssessment.saveDraftModal.description')}
      closeTitle={t('common.cancel')}
      additionalBtnTitle={t('materialityAssessment.saveDraftModal.closeWithoutSaving')}
      confirmTitle={t('materialityAssessment.saveDraftModal.saveDraft')}
      confirmVariant={BUTTON_VARIANT.primary}
      onReject={onCancel}
      onActionAdditionalBtn={onCloseWithoutSaving}
      onConfirm={onSaveDraft}
      isLoading={isLoading}
      className={styles.saveDraftModal}
    />
  );
}

export default CreateSurveyCancelModal;
